<template>
  <div class="orderConfirm">
    <van-nav-bar
      title="确认订单"
      left-text=""
      left-arrow
      class="main-nav"
      fixed
      @click-left="onClickLeft"
    />
    <div
      class="orderConfirm_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div class="myOrderDetail_content_bot">
        <div class="myOrderDetail_content_bot_top">
          <span class="span1">订单信息</span>
          <div
            class="span2"
            v-if="waitPayOrderDetail && waitPayOrderDetail.orderState == '0'"
          >
            等待支付 <span>{{ time }}</span>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_cen">
          <img
            :src="
              orderDetail.isCourse > 0
                ? orderDetail.cover
                : orderDetail.coverMaterialUrl
            "
            class="myOrderDetail_content_bot_cen_img"
          />
          <div class="myOrderDetail_content_bot_cen_rig">
            <div class="myOrderDetail_content_bot_cen_rig_title">
              {{ orderDetail.title }}
            </div>
            <div class="address">
              <img src="@/assets/images/setting/place.png" />
              <span class="address_detail">{{ form.holdAddress }}</span>
            </div>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay">
          <p>活动价格：</p>
          <div class="myOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              orderDetail.price &&
              orderDetail.price.toString().indexOf(".") > -1
                ? orderDetail.price.toString().split(".")[0]
                : orderDetail.price
            }}<span
              v-if="
                orderDetail.price &&
                orderDetail.price.toString().indexOf('.') > -1 &&
                orderDetail.price.toString().split('.')[1]
              "
              >.{{ orderDetail.price.toString().split(".")[1] }}</span
            >
          </div>
        </div>
      </div>
      <div class="course_info">
        <van-form ref="form">
          <van-field
            v-model="form.attendUserName.value"
            :required="true"
            :rules="[{ required: true, message: '请输入姓名' }]"
            name="姓名："
            label="姓名："
            placeholder="请输入"
            label-align="left"
            :border="false"
          >
            <template #input>
              <input
                v-model="form.attendUserName.value"
                :disabled="!form.attendUserName.edit"
                class="input-box"
                ref="attendUserNameInput"
              />
              <button class="change_value" @click="editName">
                <!-- @click="form.attendUserName.edit = true" -->
                修改
              </button>
            </template>
          </van-field>
          <van-field
            v-model="form.phone.value"
            :required="true"
            :rules="[{ required: true, message: '请输入手机号' }]"
            name="手机号"
            label="手机号："
            placeholder="请输入"
            label-align="left"
            :border="false"
          >
            <template #input>
              <input
                v-model="form.phone.value"
                :disabled="!form.phone.edit"
                class="input-box"
                ref="phoneInput"
              />
              <button class="change_value" @click="editPhone">修改</button>
            </template>
          </van-field>
          <van-field
            v-model="form.courseStartTime"
            :required="true"
            :rules="[{ required: true, message: '请选择开课时间' }]"
            name="开课时间"
            label="开课时间："
            placeholder="请选择"
            label-align="left"
            :border="false"
            class="open-time"
          >
            <template #input>
              <div class="time-box" @click="timeShow = true">
                <div style="margin-left: 42px">{{ form.courseStartTime }}</div>
                <img
                  src="@/assets/images/parent-course/rigth-arrow-big.png"
                  class="right-arrow"
                  alt="向右展开箭头"
                />
              </div>
            </template>
          </van-field>
          <van-field
            v-model="form.identityTypeName"
            :required="true"
            :rules="[{ required: true, message: '请选择身份类型' }]"
            name="身份类型"
            label="身份类型："
            placeholder="请选择"
            label-align="left"
            :border="false"
            @click="showPicker1 = true"
            class="open-time"
            readonly
          >
            <template #input>
              <div class="time-box" style="background: transparent">
                <div class="majro">{{ form.identityTypeName }}</div>
                <img
                  src="@/assets/images/parent-course/rigth-arrow-big.png"
                  class="right-arrow"
                  alt="向右展开箭头"
                />
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPicker1" position="bottom">
            <van-picker
              title="职业类型"
              v-model="form.identityTypeName"
              show-toolbar
              :columns="columns2"
              @confirm="onConfirm"
              @cancel="showPicker1 = false"
            />
          </van-popup>
          <van-field
            v-if="catetypeData.length > 0"
            v-model="form.career"
            :required="true"
            :rules="[{ required: true, message: '' }]"
            :name="form.identityTypeName + '分类'"
            :label="form.identityTypeName + '分类'"
            label-align="left"
            :border="false"
            class="open-time"
            readonly
          >
            <template #input>
              <div></div>
            </template>
          </van-field>
          <div class="catetype" v-show="catetypeData.length">
            <div
              v-for="(item, index) in catetypeData"
              :key="index"
              @click="setUnit(item)"
              :class="{ active: item.active }"
            >
              {{ item.name }}
            </div>
          </div>
          <van-field
            v-model="form.registrationUnit"
            :required="true"
            :rules="[{ required: true, message: '请输入报名单位' }]"
            name="报名单位"
            label="报名单位："
            placeholder="请输入"
            label-align="left"
            :border="false"
            class="open-time unit"
            type="textarea"
            maxlength="30"
          >
          </van-field>
        </van-form>
      </div>
      <div
        class="myOrderDetail_content_bot"
        v-if="waitPayOrderDetail && waitPayOrderDetail.orderState == '0'"
      >
        <div class="myOrderDetail_content_bot_pay_waitpay">
          <div class="offlineOrderDetail_content_order_num">
            <p>订单编号：</p>
            <p class="offlineOrderDetail_content_order_num_right">
              {{ orderDetail.id }}
            </p>
            <div
              :data-clipboard-text="orderDetail.id"
              class="offlineOrderDetail_content_order_num_copy"
            >
              复制
            </div>
          </div>
          <div class="offlineOrderDetail_content_order_time">
            <p>
              下单时间：<span>{{ orderDetail.createTime }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="course_warn">
        <div>下单说明：</div>
        <div>1.开课后不允许申请退款；</div>
        <div>2.开课后不支持申请延期上课；</div>
        <div>3.发票统一开课后进行开具；</div>
      </div>
      <div style="height: 80px"></div>
      <div class="myOrderDetail_content_fix">
        <div class="myOrderDetail_content_fix_left" v-if="!waitPayOrderDetail">
          <p class="myOrderDetail_content_fix_left_left">共1件，总计</p>
          <p>
            <span>¥</span
            >{{
              totalAmount && totalAmount.toString().indexOf(".") > -1
                ? totalAmount.toString().split(".")[0]
                : totalAmount
            }}<span
              v-if="
                totalAmount &&
                totalAmount.toString().indexOf('.') > -1 &&
                totalAmount.toString().split('.')[1]
              "
              >.{{ totalAmount.toString().split(".")[1] }}</span
            >
          </p>
        </div>
        <div
          class="myOrderDetail_content_fix_right"
          @click="submit"
          v-if="!waitPayOrderDetail"
        >
          去支付
        </div>
        <div
          class="offlineOrderDetail_content_fix_leftBt"
          @click="cancle"
          v-if="waitPayOrderDetail && waitPayOrderDetail.orderState == '0'"
        >
          取消订单
        </div>
        <div
          class="myOrderDetail_content_fix_right"
          @click="goPay"
          v-if="waitPayOrderDetail && waitPayOrderDetail.orderState == '0'"
        >
          ￥{{ waitPayOrderDetail && waitPayOrderDetail.originalPrice }}去支付
        </div>
      </div>
    </div>
    <dialog-common
      :infoShow="show"
      :infoMsg="infoMsg"
      :sureMsg="sureMsg"
      :cancelMsg="cancelMsg"
      @goback="close"
      @next="goAdress"
      @cance="gocance"
    ></dialog-common>
    <van-popup
      v-model="popShow"
      round
      position="bottom"
      closeable
      :style="{ height: '57%' }"
    >
      <div class="popBox">
        <div class="popBox_price">
          <span>¥</span>
          {{
            totalAmount && totalAmount.toString().indexOf(".") > -1
              ? totalAmount.toString().split(".")[0]
              : totalAmount
          }}
          <span
            v-if="
              totalAmount &&
              totalAmount.toString().indexOf('.') > -1 &&
              totalAmount.toString().split('.')[1]
            "
            >.{{ totalAmount.toString().split(".")[1] }}</span
          >
        </div>
        <div class="popBox_title">支付方式</div>
        <div class="popBox_payStyle">
          <van-radio-group v-model="radio">
            <div
              class="popBox_payStyle_wei"
              v-for="(item, index) in payTypeList"
              :key="index"
            >
              <div class="popBox_payStyle_wei_left">
                <img
                  src="@/assets/images/setting/weixin.png"
                  v-if="item.method_name == '微信支付'"
                />
                <img src="@/assets/images/setting/zhifu.png" v-else />
                <p>{{ item.method_name }}</p>
              </div>
              <div class="popBox_payStyle_wei_right">
                <van-radio :name="JSON.stringify(index)"></van-radio>
              </div>
            </div>
          </van-radio-group>
        </div>
        <van-button
          class="popBox_button"
          @click="pay"
          :loading="btnLoading"
          loading-text="支付唤起中"
        >
          立即支付￥{{ orderDetail.price }}
        </van-button>
      </div>
    </van-popup>
    <div id="zhifuB"></div>
    <course-time-dialog
      v-if="timeShow"
      :time="form.courseStartTime"
      :options="orderDetail.addresses"
      @setTime="setTime"
      @closeTimeShow="timeShow = false"
    ></course-time-dialog>
    <dialog-common
      :infoShow="cancelshow"
      :infoMsg="cancelinfoMsg"
      :sureMsg="cancelsureMsg"
      @goback="cancelclose"
      @next="cancelnext"
    ></dialog-common>
  </div>
</template>
<script>
import dialogCommon from "@/components/dialogCommon";
import courseTimeDialog from "./courseTimeDialog.vue";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import { _getRehabilitationTrainerDict } from "@/api/login";
import { setOpenId, registerWxConfig } from "@/weixinConfig";
import {
  _orderDetail,
  _addressList,
  _createOrder,
  _paymentMethodList,
  _payOrder,
  _exsitUnpaidOrders,
  _exsitPaidOrders,
  _cancelOrder,
  _modifyCourseOrder,
} from "@/api/setting";
import wx from "weixin-js-sdk";
import Clipboard from "clipboard";
export default {
  name: "outlineOrderConfirm",
  data() {
    return {
      cancelshow: false, //取消订单弹框
      cancelinfoMsg: "是否要取消该订单？",
      cancelsureMsg: "确定",
      showPicker1: false,
      adreess: {}, //地址数据
      show: false, //未填地址 弹窗 标识
      infoMsg: "", //未填地址 弹窗 内容
      sureMsg: "", //右边按钮 弹窗 按钮文字
      cancelMsg: "", //左边按钮 弹窗 按钮文字
      popShow: false, //支付方式弹窗标识
      radio: "0", //支付方式标识
      orderDetail: {}, //订单数据
      id: "", //订单id(可能用不上)
      totalAmount: 0, //下单总金额（商品价格和邮费）
      loading: false, //loading标识
      payTypeList: [], //支付方式列表
      form: {
        attendUserName: { value: "", edit: false },
        phone: { value: "", edit: false },
        courseStartTime: "",
        identityTypeId: "",
        identityTypeName: "",
        career: "",
        registrationUnit: "",
        holdAddress: "",
      },
      timeShow: false,
      totalData: [],
      columns2: [],
      catetypeData: [],
      waitPayOrderDetail: null, //待支付订单详情
      time: "", //待付款订单失效时间
      timer: null, //倒计时计时器
      btnLoading: false,
    };
  },
  components: {
    dialogCommon,
    courseTimeDialog,
  },
  created() {
    if (!sessionStorage.getItem("openid")) {
      registerWxConfig();
    }
    // if (!sessionStorage.getItem("openid")) {
    //   setOpenId("1");
    // }
    this.id = this.$route.query.id;
    if (this.id) {
      this.getOrderDetail();
    }

    this.getRehabilitationTrainerDict();
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    let children;
    if (localStorage.getItem("children")) {
      if (decryptBy(localStorage.getItem("children"))) {
        children = JSON.parse(decryptBy(localStorage.getItem("children")));
      }
    }
    if (children && children.length) {
      //儿童
      this.form.attendUserName.value = children[0].studentName;
    } else {
      this.form.attendUserName.value = user.userFullName;
    }
    this.form.phone.value = decryptBy(user.mobilePhone);
    this.orderDetail = JSON.parse(sessionStorage.getItem("orderDetails"));
    console.log(this.orderDetail, "dd");
    this.orderDetail.price = this.orderDetail.price
      ? this.orderDetail.price
      : 0;
    this.orderDetail.postPrice = this.orderDetail.postPrice
      ? this.orderDetail.postPrice
      : 0;
    this.totalAmount = Number(
      this.orderDetail.price + this.orderDetail.postPrice
    );

    let address = localStorage.getItem("adress"); //进入这个页面的所有入口需要 在localStorage存adress为空（除了地址列表页）
    if (address) {
      //如果是从地址列表页修改地址回来 需要替换地址 否则 其他入口直接取默认地址
      address = JSON.parse(address);
      this.adreess = address;
      console.log(this.adreess, "88888888");
    } else {
      this.addressList();
    }
  },
  mounted() {
    let clipborad = new Clipboard(".offlineOrderDetail_content_order_num_copy");
    clipborad.on("success", (e) => {
      this.$toast("复制成功");
    });
  },
  beforeDestroy() {},
  methods: {
    editName() {
      this.form.attendUserName.edit = true;
      this.$nextTick(() => {
        this.$refs.attendUserNameInput.focus();
      });
    },
    editPhone() {
      this.form.phone.edit = true;
      this.$nextTick(() => {
        this.$refs.phoneInput.focus();
      });
    },
    setUnit(item) {
      item.active = !item.active;
      let index = this.form.career.indexOf(item.name);
      if (item.active) {
        if (index == -1) {
          let arr = (this.form.career && this.form.career.split(",")) || [];
          arr.push(item.name);
          this.form.career = arr.join(",");
        }
      } else {
        let arr = this.form.career.split(",");
        arr.splice(index, 1);
        this.form.career = arr.join(",");
      }
    },
    getRehabilitationTrainerDict() {
      _getRehabilitationTrainerDict("rehabilitationTrainerType").then((res) => {
        if (res && res.code === 200) {
          this.totalData = res.data;
          this.columns2 = this.totalData.map((item) => item.name);
        }
      });
    },
    onConfirm(value) {
      this.catetypeData = [];
      let options = this.totalData.filter((el) => el.name == value);
      this.form.identityTypeId = options[0].code;
      this.form.identityTypeName = options[0].name;
      this.showPicker1 = false;
      // 1.分类
      options[0].children.forEach((item) => {
        if (item.code === "_type") {
          this.catetypeData = item.children.map((item) => {
            return { name: item.name, active: false };
          });
        }
      });
    },
    setTime(val, index) {
      this.form.courseStartTime = val;
      if (index != -1) {
        this.form.holdAddress = this.orderDetail.addresses[index].holdAddress;
      } else {
        this.form.holdAddress = "";
      }
    },
    changeValue(field) {
      this.form[field].edit = true;
    },
    // 返回
    onClickLeft() {
      this.$router.go(-1);
      clearInterval(this.timer);
    },
    getDecryptBy(val) {
      if (val) {
        return decryptBy(val);
      }
    },
    getAdreess(val) {
      if (val) {
        return Object.keys(val).length == 0;
      }
    },
    // 倒计时
    countDown() {
      let timeArr = this.time.split(":");
      let minute = Number(timeArr[0]); // 分
      let second = Number(timeArr[1]); // 秒
      this.timer = setInterval(() => {
        if (second == 0) {
          if (minute == 0) {
            setTimeout(() => {
              clearInterval(this.timer);
              this.getOrderDetail();
            }, 100);
          } else {
            minute -= 1;
            second = 60;
            second -= 1;
          }
        } else {
          second -= 1;
        }
        this.time =
          (minute < 10 ? "0" + minute : minute) +
          ":" +
          (second < 10 ? "0" + second : second);
      }, 1000);
    },
    //处理待付款剩余时间
    filterTime() {
      let time = "";
      let val = this.time;
      if (Number(val) < 60) {
        time = "00:" + val;
      } else {
        if (Number(val) % 60 == 0) {
          if (Number(val) / 60 > 9) {
            time = Number(val) / 60 + ":00";
          } else {
            time = "0" + Number(val) / 60 + ":00";
          }
        } else {
          if (parseInt(Number(val) / 60) > 9) {
            if (Number(val) % 60 > 9) {
              time =
                String(parseInt(Number(val) / 60)) +
                ":" +
                String(Number(val) % 60);
            } else {
              time =
                String(parseInt(Number(val) / 60)) +
                ":" +
                "0" +
                String(Number(val) % 60);
            }
          } else {
            if (Number(val) % 60 > 9) {
              time =
                "0" +
                String(parseInt(Number(val) / 60)) +
                ":" +
                String(Number(val) % 60);
            } else {
              time =
                "0" +
                String(parseInt(Number(val) / 60)) +
                ":" +
                "0" +
                String(Number(val) % 60);
            }
          }
        }
      }
      this.time = time;
      this.countDown();
    },
    // 获取订单详情
    getOrderDetail() {
      _orderDetail({
        orderId: this.id,
      }).then((res) => {
        if (res && res.code == 200) {
          this.waitPayOrderDetail = res.data;
          this.orderDetail.price = res.data.originalPrice;
          this.orderDetail.title = res.data.title;
          this.orderDetail.holdAddress = res.data.holdAddress;
          this.orderDetail.cover = res.data.coverMaterialUrl;
          this.orderDetailId = res.data.id;
          this.orderDetail.addresses = res.data.addresses;
          (this.form = {
            attendUserName: { value: res.data.attendUserName, edit: false },
            phone: { value: res.data.attendUserTel, edit: false },
            courseStartTime: res.data.courseStartTime,
            identityTypeId: res.data.identityTypeId,
            identityTypeName: res.data.identityTypeName,
            career: res.data.career,
            registrationUnit: res.data.registrationUnit,
            holdAddress: res.data.holdAddress,
          }),
            console.log(this.waitPayOrderDetail, "this.waitPayOrderDetail");
          this.waitPayOrderDetail.price = this.waitPayOrderDetail.price
            ? this.waitPayOrderDetail.price
            : 0;
          this.waitPayOrderDetail.postPrice = this.waitPayOrderDetail.postPrice
            ? this.waitPayOrderDetail.postPrice
            : 0;
          this.totalAmount = Number(
            this.waitPayOrderDetail.originalPrice +
              this.waitPayOrderDetail.postPrice
          );
          this.time = this.waitPayOrderDetail.remainingTime;
          // this.time = "3000";
          if (this.time != 0) {
            this.filterTime();
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 获取收货地址列表
    addressList() {
      this.loading = true;
      _addressList()
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data && res.data.length > 0) {
              this.adreess = res.data[0];
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //创建订单
    createOrder(val) {
      this.loading = true;
      console.log(val, "订单信息");
      _createOrder(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              this.orderDetailId = res.data.id;
              this.loading = false;
              this.getPaymentMethodList();
            }
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //跳转地址列表页
    goAdressList() {
      this.$router.push({
        path: "/adressList",
      });
    },
    //跳转添加地址页面
    goAdress(item) {
      if (item == 1) {
        this.$router.push({
          path: "/addAdress",
        });
      } else {
        this.gocreateOrder();
      }
      this.show = false;
    },
    gocance(item) {
      if (item == 2) {
        this.$router.push({
          path: "/myOrder",
        });
      }
      this.show = false;
    },
    //待付款 点击去付款弹窗支付方式
    goPay() {
      // if (!sessionStorage.getItem("openid")) {
      //   setOpenId("1");
      // }
      let params = {
        productId: this.waitPayOrderDetail.productId,
      };
      _exsitPaidOrders(params).then((res) => {
        if (res.data) {
          this.$toast("与已购买课程冲突，无法购买");
        } else {
          //调修改课程开始时间接口
          _modifyCourseOrder({
            id: this.waitPayOrderDetail.id,
            courseStartTime: this.form.courseStartTime,
            holdAddress: this.form.holdAddress,

            attendUserId: this.waitPayOrderDetail.attendUserId,
            attendUserName: this.form.attendUserName.value,
            attendUserTel: this.form.phone.value,
            career: this.form.career,
            identityTypeId: this.form.identityTypeId,
            identityTypeName: this.form.identityTypeName,
            postAddress: this.waitPayOrderDetail.postAddress,
            postAddressId: this.waitPayOrderDetail.postAddressId,
            recipientName: this.waitPayOrderDetail.recipientName,
            recipientTel: this.waitPayOrderDetail.recipientTel,
            registrationUnit: this.form.registrationUnit,
          }).then((res) => {
            if (res.code == 200) {
              this.getOrderDetail();
              this.getPaymentMethodList();
            } else {
              this.$toast(res.message);
            }
          });
        }
      });
    },
    //点击立即支付 需创建订单
    submit() {
      this.$refs.form.validate().then(() => {
        let params = {
          productId: this.orderDetail.id,
        };
        _exsitUnpaidOrders(params).then((res) => {
          if (res.data) {
            this.infoMsg = "您有未支付的订单"; //未填地址 弹窗 内容
            this.sureMsg = "提交订单"; //未填地址 弹窗 按钮文字
            this.cancelMsg = "查看订单"; //弹窗按钮显示
            this.show = true;
          } else {
            this.gocreateOrder();
          }
        });
      });
    },
    gocreateOrder() {
      let param = {};
      // param.price = this.totalAmount;
      // param.postAddress = this.orderDetail.postAddress;
      // param.postAddressId = this.orderDetail.postAddressId;
      // param.postPrice = this.orderDetail.postPrice;
      // param.productCode = this.orderDetail.productCode;
      // param.productId = this.orderDetail.productId;
      // param.productName = this.orderDetail.productName;
      // param.recipientName = this.orderDetail.recipientName;
      // param.productType = this.orderDetail.productType;
      // param.recipientTel = this.orderDetail.recipientTel;
      // param.userId = this.orderDetail.userId;
      // param.userName = this.orderDetail.userName;
      param.attendUserName = this.form.attendUserName.value;
      param.attendUserTel = this.form.phone.value;
      console.log(this.form);
      param.career = this.form.career;
      param.courseStartTime = this.form.courseStartTime;
      param.holdAddress = this.form.holdAddress;
      param.identityTypeId = this.form.identityTypeId;
      param.identityTypeName = this.form.identityTypeName;
      param.originalPrice = this.orderDetail.price;
      param.registrationUnit = this.form.registrationUnit;
      param.payTypeId = "";
      param.payTypeName = "";
      param.postAddress =
        this.adreess.province +
        this.adreess.city +
        this.adreess.county +
        this.adreess.address;
      param.postAddressId = this.adreess.id;
      param.postPrice = this.orderDetail.postPrice;
      param.productCode = "";
      param.productId = this.orderDetail.id;
      param.productName = this.orderDetail?.title;
      param.productType = this.orderDetail?.isCourse == 0 ? 1 : 2;
      if (this.orderDetail.isPost) {
        param.recipientName = this.adreess.contacts;
        param.recipientTel = this.adreess.phone;
      } else {
        param.recipientName = "";
        param.recipientTel = "";
      }

      param.userId = "";
      param.userName = "";

      this.createOrder(param);
    },
    // 获取支付方式
    getPaymentMethodList() {
      _paymentMethodList({
        clientType: "wap",
      }).then((res) => {
        if (res && res.statusCode == 200) {
          res.data = res.data.slice(0, 2);

          this.payTypeList = res.data;
          if (res.data && res.data.length > 0) {
            //调起选择支付模式弹窗
            this.popShow = true;
          }
        }
      });
    },
    //关闭弹窗
    close() {
      this.show = false;
    },
    //支付
    pay() {
      this.btnLoading = true;
      if (this.radio == "0") {
        registerWxConfig();
        //radio为 0==微信   1==支付宝
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 1,
          openid,
          order_price: this.orderDetail.price,
          order_sn: this.orderDetailId,
          system_id: 1,
        };
        _payOrder(params).then((res) => {
          if (res.code == 200) {
            res.data = JSON.parse(res.data);

            wx.chooseWXPay({
              timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
              package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
              paySign: res.data.paySign, // 支付签名
              success: function (res) {
                console.log("支付成功了", res);
                // 支付成功后的回调函数
                window.location.href = "/#/paymentCallbackJump";
              },
              fail: function (error) {
                console.log("error", error);
                window.location.href = "/#/paymentCallbackJump";
              },
            });
          } else {
            Toast(res.message);
          }
          this.btnLoading = false;
        });
      } else {
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 2,
          openid,
          order_price: this.orderDetail.price,
          order_sn: this.orderDetailId,
          system_id: 2,
        };
        _payOrder(params)
          .then((res) => {
            if (res.code == 200) {
              const div = document.getElementById("zhifuB");
              div.innerHTML = res.data;
              div.getElementsByTagName("form")[0].submit();
            } else {
              Toast(res.message);
            }
            this.btnLoading = false;
          })
          .finally((res) => {
            Toast(res.message);
            this.btnLoading = false;
          });
      }
    },
    cancelnext() {
      this.cancelOrder(this.id);
    },
    //点击取消订单
    cancle() {
      this.cancelshow = true;
    },
    //关闭取消订单弹框
    cancelclose() {
      this.cancelshow = false;
    },
    //取消订单接口
    cancelOrder(data) {
      this.loading = true;
      _cancelOrder({
        orderId: data,
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.onClickLeft();
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.orderConfirm {
  height: 100%;
  background: #f5f7fa;
  .orderConfirm_content {
    padding-top: 48px;
    position: relative;
    height: 100%;
    .myOrderDetail_content_fix {
      position: fixed;
      width: 375px;
      height: 81px;
      background: #fff;
      display: flex;
      bottom: 0;
      justify-content: space-around;
      align-items: center;
      .offlineOrderDetail_content_fix_leftBt {
        width: 150px;
        height: 40px;
        background: #f3f6f7;
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #626a6b;
        text-align: center;
        line-height: 40px;
        margin-left: 10px;
        margin-top: 10px;
      }
      .myOrderDetail_content_fix_left {
        margin-left: 20px;
        display: flex;
        align-items: center;
        p {
          font-size: 26px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #ee3721;
          span {
            font-size: 18px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #ee3721;
          }
        }
        .myOrderDetail_content_fix_left_left {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
          margin-top: 5px;
          margin-right: 9px;
        }
      }
      .myOrderDetail_content_fix_right {
        width: 150px;
        height: 40px;
        background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        margin-left: 10px;
        margin-top: 10px;
      }
    }
    .myOrderDetail_content_noAddress {
      width: 375px;
      background: #ffffff;
      .myOrderDetail_content_noAddress_cont {
        display: flex;
        justify-content: space-between;
        padding: 38px 0;
        .myOrderDetail_content_noAddress_cont_left {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-right: 10px;
            margin-left: 20px;
          }
          div {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #949c9d;
          }
        }
        .myOrderDetail_content_noAddress_cont_right {
          width: 22px;
          height: 22px;
          margin-right: 30px;
        }
      }
      .myOrderDetail_content_address_bottom {
        display: block;
        width: 100%;
      }
    }
    .myOrderDetail_content_address {
      width: 375px;
      background: #ffffff;
      .myOrderDetail_content_address_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        padding-top: 10px;
        margin-left: 10px;
        .myOrderDetail_content_address_top_left {
          display: flex;
          align-items: center;
        }

        img {
          width: 22px;
        }
        .myOrderDetail_content_address_top_name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
          margin-left: 8px;
          margin-right: 16px;
        }
        .myOrderDetail_content_address_top_phone {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
        }
        .myOrderDetail_content_address_top_right {
          width: 32px;
          height: 20px;
          background: #fcd7d3;
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ee3721;
          text-align: center;
          line-height: 20px;
          margin-left: 15px;
        }
      }
      .myOrderDetail_content_address_contentBox {
        display: flex;
        justify-content: space-between;
        .myOrderDetail_content_address_content {
          width: 256px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #626a6b;
          margin-left: 40px;
          margin-top: 8px;
          margin-bottom: 14px;
        }
        img {
          width: 22px;
          height: 22px;
          margin-right: 30px;
          margin-top: 7px;
        }
      }

      .myOrderDetail_content_address_bottom {
        display: block;
        width: 100%;
      }
    }
    .myOrderDetail_content_bot {
      padding: 12px 24px 8px 15px;
      width: 375px;
      background: #ffffff;
      margin: 8px 0;
      .myOrderDetail_content_bot_top {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e4344;
        margin-bottom: 12px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        .span1 {
          font-size: 16px;
          font-weight: 500;
        }
        .span2 {
          font-size: 14px;
          color: #fa7d00;
        }
      }
      .myOrderDetail_content_bot_cen {
        .myOrderDetail_content_bot_cen_img {
          display: inline-block;
          width: 128px !important;
          height: 72px;
          border-radius: 4px;
          margin-right: 12px;
        }
        .myOrderDetail_content_bot_cen_rig {
          display: inline-block;
          width: 196px;
          .address {
            margin-top: 8px;
            img {
              width: 18px;
              height: 18px;
              display: inline-block;
            }
            .address_detail {
              font-size: 14px;
              font-weight: 400;
              color: #ee3721;
              line-height: 20px;
              vertical-align: top;
            }
          }
          .myOrderDetail_content_bot_cen_rig_title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2e4344;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .myOrderDetail_content_bot_cen_rig_biaoqian {
            display: inline-block;
            height: 22px;
            background: rgba(250, 125, 0, 0.1);
            border-radius: 11px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fa7d00;
            line-height: 22px;
            text-align: center;
            padding: 0 8px;
            margin-top: 4px;
          }
        }
      }
      .myOrderDetail_content_bot_pay {
        margin-left: 6px;
        margin-right: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
      }
      .myOrderDetail_content_bot_pay_waitpay {
        .offlineOrderDetail_content_order_num {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          .offlineOrderDetail_content_order_num_right {
            width: 195px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
            color: #2e4344;
            text-align: left;
          }
          div {
            width: 40px;
            height: 20px;
            background: #f5f7fa;
            border-radius: 3px;
            text-align: center;
            line-height: 20px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2e4344;
          }
        }
        .offlineOrderDetail_content_order_time {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-top: 12px;
        }
      }

      .myOrderDetail_content_bot_pay,
      .myOrderDetail_content_bot_pay1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #949c9d;
        }
        .myOrderDetail_content_bot_pay_way {
          display: flex;
          align-items: center;
          p {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2e4344;
          }
        }
        .myOrderDetail_content_bot_pay_money,
        .myOrderDetail_content_bot_pay_money1 {
          font-size: 20px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #626a6b;
          span {
            font-size: 14px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #626a6b;
          }
        }
      }
      .myOrderDetail_content_bot_pay1 {
        margin-top: 24px;
        p {
          font-size: 14px;
          color: #2e4344;
        }
        .myOrderDetail_content_bot_pay_money {
          font-size: 26px;
          color: #ee3721;
          span {
            font-size: 18px;
            color: #ee3721;
          }
        }
      }
    }
    .course_info {
      width: 375px;
      padding: 0 14px 21px;
      background: #fff;

      ::v-deep .van-cell {
        .van-field__body {
          .van-field__control {
            text-align: right;
          }
          .van-field__control:focus {
            text-align: left;
          }
        }
      }
      .change_value {
        width: 40px;
        height: 20px;
        line-height: 20px;
        background: #f5f7fa;
        border-radius: 3px;
      }
      .input-box {
        width: 178px;
        text-align: right;
        margin-right: 6px;
        background: transparent !important;
      }
      .time-box {
        width: 254px;
        height: 38px;
        background: rgba(174, 209, 214, 0.1);
        border-radius: 4px;
        margin-top: -6px;
        display: flex;
        align-items: center;
      }
      .majro {
        margin-left: 42px;
        width: 166px;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
        color: #00aadf;
      }
      .right-arrow {
        width: 22px;
        height: 22px;
        position: absolute;
        right: 10px;
      }
      .open-time {
        ::v-deep .van-cell__title {
          width: auto;
          margin-right: 0;
        }
      }
      .unit {
        ::v-deep .van-field__control {
          background-color: rgba(174, 209, 214, 0.1);
          width: 254px;
        }
      }
      .catetype {
        display: flex;
        flex-wrap: wrap;
        background: #fff;
        > div {
          margin-left: 10px;
          margin-right: 10px;
          width: 143px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: rgba(0, 170, 223, 0.1);
          border-radius: 4px;
          margin-bottom: 10px;
          color: #00aadf;
        }
        div.active {
          background: #00aadf;
          color: #fff;
        }
      }
    }
    .course_warn {
      padding-left: 20px;
      padding-top: 8px;
      padding-bottom: 20px;
      font-size: 12px;
      color: #626a6b;
      line-height: 17px;
      background-color: RGBA(245, 247, 250, 1);
    }
  }
  .popBox_price {
    font-size: 32px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ee3721;
    text-align: center;
    margin-top: 19px;
    span {
      font-size: 24px;
    }
  }
  .popBox_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #484848;
    margin-top: 20px;
    margin-left: 20px;
  }
  .popBox_payStyle_wei {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    .popBox_payStyle_wei_left {
      display: flex;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
        margin-left: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #484848;
      }
    }
    .popBox_payStyle_wei_right {
      margin-right: 40px;
    }
  }
  .popBox_button {
    width: 300px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 37.5px;
    margin-top: 56px;
  }
}
</style>
